(function () {
window.allowRenderOnLogin = true;

})();
//# sourceMappingURL=mainPage.js.map
